// extracted by mini-css-extract-plugin
module.exports = {"tab":"_89a0534","focused":"_fa66c2d","icon":"_3f4850c","hovered":"_6252a86","selectionIndicator":"_5f0403b","tabContent":"_b14fc0f"};